import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import AuthGuard from "./auth/AuthGuard";
import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import {
  dashboardPaths,
  profilePaths,
  manageUsersPaths,
  registerPaths,
  usersPaths,
  reservationPaths,
  serviceOrdersPaths,
  equipmentPaths,
  operatorShcedulePaths,
  financePaths,
  reportsPaths,
  useTermsPaths
} from "./path";

// session pages
const NotFound = Loadable(lazy(() => import("app/views/sessions/NotFound")));
const JwtLogin = Loadable(lazy(() => import("app/views/sessions/JwtLogin")));
const JwtRegister = Loadable(
  lazy(() => import("app/views/sessions/JwtRegister"))
);
const JwtAdress = Loadable(lazy(() => import("app/views/sessions/JwtAdress")));
const ForgotPassword = Loadable(
  lazy(() => import("app/views/sessions/ForgotPassword"))
);
const ResetPassword = Loadable(
  lazy(() => import("app/views/sessions/ResetPassword"))
);
const ActivateAccount = Loadable(
  lazy(() => import("app/views/sessions/ActivateAccount"))
);
const ConfirmReservation = Loadable(
  lazy(() => import("app/views/reservation/public/ConfirmReservation"))
);

const Routes = () => {
  const routes = [
    {
      element: (
        <AuthGuard>
          <MatxLayout />
        </AuthGuard>
      ),
      children: [
        ...dashboardPaths,
        ...profilePaths,
        ...manageUsersPaths,
        ...registerPaths,
        ...usersPaths,
        ...reservationPaths,
        ...serviceOrdersPaths,
        ...equipmentPaths,
        ...operatorShcedulePaths,
        ...financePaths,
        ...reportsPaths,
        ...useTermsPaths,
      ],
    },

    { path: "/session/404", element: <NotFound /> },
    { path: "/session/signin", element: <JwtLogin /> },
    { path: "/session/signup", element: <JwtRegister /> },
    { path: "/session/adress", element: <JwtAdress /> },
    { path: "/session/forgotPassword", element: <ForgotPassword /> },
    { path: "/session/resetPassword/:url_token", element: <ResetPassword /> },
    {
      path: "/session/activateAccount/:url_token",
      element: <ActivateAccount />,
    },
    { path: "/confirmReservation/:urlToken", element: <ConfirmReservation /> },

    { path: "/", element: <Navigate to="session/signin" /> },
    { path: "*", element: <NotFound /> },
  ];

  return routes;
};

export default Routes;
